export default {
    namespaced: true,
    state: {
        products: []
    },
    mutations:{
        set_product_quantity(state, data) {
            let product = state.products.find(product => product[3] === data.variantSku)
            product[0].value = data.quantity
        },
        set_products(state, data) {
            state.products = data
        },
        add_product(state, data) {
            state.products.push(data)
        },
        remove_product(state, data) {
            state.products = state.products.filter(product => !(product[3] === data[3]))
        },
        clear_products(state) {
            state.products = []
        }
    },
    actions:{
        async add_to_cart(context) {
            let products = context.getters.getProducts.map(product => { return { "variantSku": product[3], "quantity": product[0].value }})
            await context.dispatch('ecom/tryAddToCartByVariantSkus', products, {root:true}) 
                .then(async () => {
                    await context.dispatch('ecom/getCart', {}, {root: true})
            })
        },
        update_products(context, data) {
            let products = context.getters.getProducts
            data.entries.forEach(product => {
                if (product[0].value === undefined) return

                if (product[0].value > 0) {
                    let existingProduct = products.find(p => p[3] === product[3])
                    if (existingProduct) {

                        context.commit('set_product_quantity', { quantity: product[0].value, variantSku: product[3] })
                    }
                    else {
                        context.commit('add_product', product)
                    }
                }
                else if (product[0].value === 0) {
                    context.commit('remove_product', product)
                }
            })
        }
    },
    getters: {
        getProducts(state) {
            return state.products        
        }
    }
}